// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-container-FacebookVerification-FacebookVerificationContainer-index-module__wrapper--2LI3d"};